import React from "react";
import APIService from "../../Service/APIService";
import GenericDashboard from "../GenericDashboard/GenericDashboard";
import { Input, Button, Modal, Form, Row, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import Select from "react-select";
import TitleBar from "../../common/title-bar/title-bar.js";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import { Spin, Flex } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const DistributorUser = (props) => {
  const { user } = useAuth();
  const userData = user;
  const { distributorData } = props;
  const [distUsers, setDistUsers] = React.useState([]);
  const [prefix, setPrefix] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [role, setRole] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const distUsersRequestIdRef = React.useRef(0);

  const [modalUserVisible, setModalUserVisible] = React.useState(false);

  const handleModalOk = () => {
    setModalUserVisible(false);
  };
  const handleModalCancel = () => {
    setModalUserVisible(false);
  };

  const handleUserNew = () => {
    setModalUserVisible(true);
  };

  React.useEffect(() => {
    const distributorID = distributorData?.ID;
    if (!distributorID) {
      setDistUsers([]);
      return;
    }

    const currentRequestId = distUsersRequestIdRef.current + 1;
    distUsersRequestIdRef.current = currentRequestId;
    let isCancelled = false;

    const getAllDistUsers = async () => {
      try {
        const apiServe = new APIService();
        const response = await apiServe.getDataFromBackend(
          `getdistributorusersbydistributor?DistributorID=${distributorID}`
        );
        console.log("Dist Users: ", response?.data?.data);
        const tempData = (response?.data?.data || []).map((item) => {
          return {
            ...item,
            Role: item.IsManager ? "Manager" : "User",
            RoleType: item.IsManager ? "Manager" : "User",
          };
        });

        if (
          !isCancelled &&
          distUsersRequestIdRef.current === currentRequestId
        ) {
          setDistUsers(tempData);
        }
      } catch (error) {
        console.error(
          "[DistributorUser] Failed to fetch distributor users",
          error
        );
        if (
          !isCancelled &&
          distUsersRequestIdRef.current === currentRequestId
        ) {
          setDistUsers([]);
        }
      }
    };

    setDistUsers([]);
    getAllDistUsers();

    return () => {
      isCancelled = true;
    };
  }, [distributorData?.ID]);

  const [isLoading, setIsLoading] = React.useState(false);

  const addDistributorUser = async () => {
    let isValidate = true;
    if (!firstName || !lastName || !email || !phone) {
      isValidate = false;
    }
    if (!isValidate) {
      Swal.fire({
        title: "Error!",
        text: "Please fill all the fields",
        icon: "error",
        confirmButtonText: "Ok",
      });
      return;
    }
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this user to this distributor?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setModalUserVisible(false);
        setIsLoading(true);
        const postObj = {
          DistributorID: distributorData?.ID,
          DistributorName: distributorData?.DistributorName,
          Prefix: prefix,
          FirstName: firstName,
          LastName: lastName,
          Email: email,
          Phone: phone,
          Active: true,
          Type: "Distributor",
          IsManager: role === "Manager" ? true : false,
        };
        console.log("Post Object: ", postObj);
        const serv = new APIService();
        const response = await serv.addDataToBackend(postObj, "register");
        console.log("Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          setIsLoading(false);
          Swal.fire({
            icon: "success",
            title: "User Added",
            text: "User has been added successfully",
          }).then(() => {
            window.href = "/Distributor/"+distributorData?.ID;
            window.location.reload();
          });
        } else {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Error while adding user. This email might already exist. Please verify and try again.",
          });
          return;
        }
      }
    });
  };
  console.log([distributorData], "distributorData >>>>>>1");

  console.log(distUsers, "dist users >>>>1");

  const addUserButton =
    userData?.Type === "Admin" && hasPermission(userData, "manage_distributors.edit") ? (
      <Button
        onClick={handleUserNew}
        type="primary"
        icon={<PlusOutlined />}
        style={{
          background: colors["primaryColor"],
        }}
      >
        Add User
      </Button>
    ) : null;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      {isLoading && (
        <Flex align="center" gap="middle">
          <Spin
            indicator={
              <LoadingOutlined
                style={{
                  fontSize: 48,
                }}
                spin
              />
            }
            fullscreen
          />
        </Flex>
      )}
      <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
        <TitleBar label="Sales Reps" rightFilterBarComponents={addUserButton} />
        {distUsers && (
          <GenericDashboard
            data={distUsers}
            screen="DistributorData"
          />
        )}
        <Modal
          title="Add New Distributor User"
          open={modalUserVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          centered={true}
          footer={null}
          style={{ width: "1000px" }}
        >
          <div>
            <Form layout="vertical">
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Distributor">
                    <Select
                      defaultValue={{
                        label: `${distributorData?.DistributorName}`,
                        value: `${distributorData?.ID}`,
                      }}
                      value={{
                        label: `${distributorData?.DistributorName}`,
                        value: `${distributorData?.ID}`,
                      }}
                      isDisabled={true}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={4}>
                  <Form.Item label="Prefix">
                    <Input
                      placeholder="Dr."
                      onChange={(e) => setPrefix(e.target.value)}
                      value={prefix}
                    />
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#616161",
                      }}
                    >
                      Optional
                    </p>
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="First Name">
                    <Input
                      placeholder="Enter First Name"
                      onChange={(e) => setFirstName(e.target.value)}
                      value={firstName}
                    />
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="Last Name">
                    <Input
                      placeholder="Enter Last Name"
                      onChange={(e) => setLastName(e.target.value)}
                      value={lastName}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row
                gutter={16}
                style={{ marginTop: "-15px", marginBottom: "-10px" }}
              >
                <Col span={8}>
                  <Form.Item label="Role">
                    <Select
                      placeholder={"Select Role"}
                      value={{ label: role, value: role }}
                      onChange={(e) => setRole(e.value)}
                      options={[
                        { label: "User", value: "User" },
                        { label: "Manager", value: "Manager" },
                      ]}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Email">
                    <Input
                      placeholder="Enter Email"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Phone">
                    <Input
                      placeholder="Enter Phone"
                      onChange={(e) => setPhone(e.target.value)}
                      value={phone}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <p
                style={{
                  fontSize: "16px",
                  fontWeight: "400",
                  color: "#2d2d2d",
                }}
              >
                Adding a user does not give them access to Tissue Vault.
                Please activate the user to invite them to Tissue Vault.
              </p>
              <Button
                type="primary"
                style={{ background: "#27a907" }}
                onClick={addDistributorUser}
              >
                Add Contact and Activate
              </Button>
            </Form>
          </div>
        </Modal>
      </div>

    </div>
  );
};

export default DistributorUser;
